import { X } from 'lucide-react';
import { formatDisplayDateTime } from '@/utils/date';
import { formatLocation } from '@/utils/formatLocation';
import type { InstituteSubmissionDetail } from '../types/instituteSubmission.types';
import { getMapPosition } from '../utils/mapPosition';
import { CopyableGpsPoint } from './CopyableGpsPoint';
import { InstitutePhoto } from './InstitutePhoto';
import { PhotoCaptureStamp } from './PhotoCaptureStamp';

const DETAIL_ROW_CLASS =
  'flex items-center justify-between gap-3 border-b py-1 text-xs last:border-0';

function NotSentValue() {
  return (
    <span className="inline-flex items-center gap-1 text-danger-foreground">
      <X className="size-3.5" aria-hidden />
      Not sent
    </span>
  );
}

interface InstituteSubmissionCaptureSectionProps {
  submission: InstituteSubmissionDetail;
}

export function InstituteSubmissionCaptureSection({
  submission,
}: InstituteSubmissionCaptureSectionProps) {
  const capturePosition = getMapPosition(submission);

  return (
    <section className="flex flex-col gap-2">
      <InstitutePhoto
        photoUrl={submission.photoUrl}
        instituteName={submission.current.name}
        stamp={
          <PhotoCaptureStamp
            latitude={submission.latitude}
            longitude={submission.longitude}
            capturedAt={submission.capturedAt}
          />
        }
      />

      <dl className="flex flex-col">
        <div className={DETAIL_ROW_CLASS}>
          <dt className="text-muted-foreground">GPS point</dt>
          <dd className="text-right font-medium">
            {capturePosition ? <CopyableGpsPoint position={capturePosition} /> : <NotSentValue />}
          </dd>
        </div>
        <div className={DETAIL_ROW_CLASS}>
          <dt className="text-muted-foreground">Date & Time</dt>
          <dd className="text-right font-medium">
            {submission.capturedAt ? (
              formatDisplayDateTime(submission.capturedAt)
            ) : (
              <NotSentValue />
            )}
          </dd>
        </div>
        <div className={DETAIL_ROW_CLASS}>
          <dt className="text-muted-foreground">Location</dt>
          <dd className="max-w-44 text-right font-medium">
            {formatLocation(submission.current) ?? 'Not set'}
          </dd>
        </div>
      </dl>
    </section>
  );
}
